module.exports = __webpack_public_path__ + "img/bicycle-blue.af6882b7.svg";